
  import { defineComponent, ref, getCurrentInstance } from "vue";
  import { MemberApi } from "@/services/Api";
  import { useAsyncSpinner } from "@/services/Spinner";
  import { useI18n } from "vue-i18n";
  import BaseButton from "@/components/BaseButton.vue";
  
  export default defineComponent({
    components: {
      BaseButton
    },
    emits: { 
      "update:password" (message: string) {
        return message;
      }
    },
    setup(props, context) {
      const currentPassword = ref<string>();
      const password = ref<string>();
      const confirmPassword = ref<string>();
      const errorMessage = ref<string>();
      const successMessage = ref<string>();
      const { t } = useI18n();

      const onSubmit = async(): Promise<void> => {
        successMessage.value = "";
        errorMessage.value = "";

        await useAsyncSpinner(async () => {
          if (!currentPassword.value || !password.value || !confirmPassword.value)  {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return
          }

          if (password.value !== confirmPassword.value) {
            errorMessage.value = t('Registererror.Passwordmatch');
            return;
          }

          if (password.value.length < 10) {
              errorMessage.value = t('Registererror.Passwordlength');
              return;
          }

          const model = await MemberApi.changePassword(currentPassword.value, password.value, confirmPassword.value);
          
          if (model.success) { 
            successMessage.value = t("Common.PasswordChanged");
            context.emit("update:password", successMessage.value ? successMessage.value : "");
          } else {
            
            errorMessage.value = model.messages?.join("<br />");
            if(errorMessage.value == "PasswordMismatch") {
              errorMessage.value = t("Common.PasswordMismatch");
            } else if(errorMessage.value == "PasswordTooShort") {
              errorMessage.value = t("Common.PasswordMinLength");
            }
          }
        });
      };
  
      return {
        currentPassword,
        password,
        confirmPassword,
        errorMessage,
        successMessage,
        onSubmit,
      };
    },
  });
  